export const INPUT_RULE_ORDERED_LIST = {
  type: 'wrapping',
  matcher: /^1\. $/,
  replaceWith: 'orderedList'
};
export const INPUT_RULE_UNORDERED_LIST = {
  type: 'wrapping',
  matcher: /^[\*\-\+] $/,
  replaceWith: 'unorderedList'
};
export const INPUT_RULE_ORDERED_NESTED_LIST = {
  type: 'wrapping',
  matcher: /^1\. $/,
  replaceWith: 'orderedNestedList'
};
export const INPUT_RULE_UNORDERED_NESTED_LIST = {
  type: 'wrapping',
  matcher: /^[\*\-\+] $/,
  replaceWith: 'unorderedNestedList'
};